export const getTokenFromStorage = () => {
  // 这是从全局存储获取的
  if (
    !(typeof voltaliStore === 'undefined') &&
    voltaliStore &&
    voltaliStore.getExtras
  ) {
    const extras = voltaliStore.getExtras('extras')
    return extras && extras.token
  }
  return null
}